import {InternalStaticImageType} from '../../atoms/StaticImage/InternalStaticImageType.enum';
import {StaticImage} from '../../atoms/StaticImage/StaticImage';
import {StaticImageProps} from '../../atoms/StaticImage/StaticImageProps.interface';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';

interface DialogImageProps extends Omit<StaticImageProps, 'imageType'> {
  imageType?: StaticImageType | InternalStaticImageType;
}

export function DialogImage({imageType, ...props}: DialogImageProps) {
  if (!imageType) {
    return null;
  }

  return (
    <div className="flex justify-center">
      <StaticImage imageType={imageType} {...props} />
    </div>
  );
}

export const DialogImageType = (<DialogImage />).type;
